var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-content__item-page ui-colors ui-item-page" },
    [
      _c("h2", { staticClass: "ui-item-page__title" }, [_vm._v("UI Color")]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Main color"),
              ]),
              _vm._l(_vm.ui_colors.main_color, function (color, index) {
                return _c("div", { key: index, staticClass: "ui-color" }, [
                  _c(
                    "div",
                    {
                      staticClass: "ui-color__item",
                      style: "background:" + color.hex,
                    },
                    [
                      _c("div", { staticClass: "ui-color__text" }, [
                        _vm._v(_vm._s(color.title)),
                      ]),
                      _c("div", { staticClass: "ui-color__hex" }, [
                        _vm._v(_vm._s(color.hex)),
                      ]),
                    ]
                  ),
                ])
              }),
            ],
            2
          ),
        ]),
      ]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Secondary color"),
              ]),
              _vm._l(_vm.ui_colors.secondary_color, function (color, index) {
                return _c("div", { key: index, staticClass: "ui-color" }, [
                  _c(
                    "div",
                    {
                      staticClass: "ui-color__item",
                      style: "background:" + color.hex,
                    },
                    [
                      _c("div", { staticClass: "ui-color__text" }, [
                        _vm._v(_vm._s(color.title)),
                      ]),
                      _c("div", { staticClass: "ui-color__hex" }, [
                        _vm._v(_vm._s(color.hex)),
                      ]),
                    ]
                  ),
                ])
              }),
            ],
            2
          ),
        ]),
      ]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Neutral Color"),
              ]),
              _vm._l(_vm.ui_colors.text_color, function (color, index) {
                return _c("div", { key: index, staticClass: "ui-color" }, [
                  _c(
                    "div",
                    {
                      staticClass: "ui-color__item",
                      style: "background:" + color.hex,
                    },
                    [
                      _c("div", { staticClass: "ui-color__text" }, [
                        _vm._v(_vm._s(color.title)),
                      ]),
                      _c("div", { staticClass: "ui-color__hex" }, [
                        _vm._v(_vm._s(color.hex)),
                      ]),
                    ]
                  ),
                ])
              }),
            ],
            2
          ),
        ]),
      ]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Border Color"),
              ]),
              _vm._l(_vm.ui_colors.border_color, function (color, index) {
                return _c("div", { key: index, staticClass: "ui-color" }, [
                  _c(
                    "div",
                    {
                      staticClass: "ui-color__item",
                      style: "background:" + color.hex,
                    },
                    [
                      _c("div", { staticClass: "ui-color__text" }, [
                        _vm._v(_vm._s(color.title)),
                      ]),
                      _c("div", { staticClass: "ui-color__hex" }, [
                        _vm._v(_vm._s(color.hex)),
                      ]),
                    ]
                  ),
                ])
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-block" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-6" }, [
          _c("h5", { staticClass: "ui-item-page__sub-title" }, [
            _vm._v("Gradient"),
          ]),
          _c("div", { staticClass: "ui-gradient-block main-gradient" }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }